module.exports = __webpack_public_path__ + "img/pay_code.06f47d60.png";